import { stepModel } from '../step/step-model';
import { withPlayer } from '../step/player/withPlayer';
import { stepWritingModel } from './step-writing-model';

var createPlayer = function createPlayer(props) {
  return {
    submitStep: function submitStep() {
      var step = props.step,
          player = props.player;

      var answers = stepWritingModel.getAnswers(step, player.values);
      var correct = stepModel.areAnswersCorrect(step, answers);
      // now that we know about the correctness, remove the example
      //  because otherwise the user has that included in their score.
      //  if there is an example it is the first answer
      if (stepWritingModel.hasExample(step)) {
        answers.shift();
      }
      player.submitStep({ progressStepType: props.progressStepType, answers: answers, correct: correct });
    },
    tryAgain: function tryAgain() {
      var _this = this;

      // when retrying, blank out only the answers that the user got wrong
      //
      //  this is made extra complicated because the step could have an example as the
      //  first value, but the answers will not have the example in them
      var hasExample = stepWritingModel.hasExample(props.step);
      var answeredRightValues = this.values.map(function (value, i) {
        if (hasExample) {
          if (i === 0 || _this.answers[i - 1].correct) {
            return value;
          }
          return '';
        }
        return _this.answers[i].correct ? value : '';
      });
      props.player.tryAgain({ values: answeredRightValues });
    }
  };
};

export var withWritingStepPlayer = withPlayer(createPlayer);